<template>
  <div>
    <TheReviewASubmittedDeathRecordRightAside v-if="this.$route.name == 'Review a submitted death record'" />
    <TheMinicartAside v-if="this.$route.name == 'Order form'" />
  </div>
</template>

<script>
import TheMinicartAside from '@/views/order/TheMinicartAside.vue'
import TheReviewASubmittedDeathRecordRightAside from '@/components/reviewasubmitteddeathrecord/TheReviewASubmittedDeathRecordRightAside.vue'

export default {
  components: {
    TheReviewASubmittedDeathRecordRightAside,
    TheMinicartAside
  }
}
</script>
